import React from 'react';
import { Button } from 'react-bootstrap';
import { EditUserModal } from '~/components/Admin';
import { moment, momentFormats } from '~/vendorConfigs/moment';

interface UserRowProps {
    user: UserType;
    refreshUserList: () => void;
}
export function UserRow({ user, refreshUserList }: UserRowProps) {
    const [showModal, setShowModal] = React.useState(false);

    return (
        <tr>
            <td>
                <button className="link-button" type="button" onClick={() => setShowModal(true)}>
                    {user.first_name} {user.last_name}
                </button>
            </td>
            <td>{user.email}</td>
            <td>{user.title}</td>
            <td>{moment(user.created_at).format(momentFormats.DATE_TIME)}</td>
            <td>
                {user.last_login ? moment(user.last_login).format(momentFormats.DATE_TIME) : ''}
            </td>
            <td className="p-0 align-middle text-center">
                <Button
                    variant="default"
                    size="sm"
                    onClick={() => setShowModal(true)}
                    aria-label="Edit User"
                >
                    <i className="fa-solid fa-edit" />
                </Button>
                <EditUserModal
                    user={user}
                    show={showModal}
                    setShow={setShowModal}
                    refreshUserList={refreshUserList}
                />
            </td>
        </tr>
    );
}
